import
  React
from 'react';

import {
  HContainer,
  Text
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../../../constants';

export const PleaseNote = (props) => {

  return (

    <HContainer
      margin={'8px 0 32px'}
      padding={'8px'}
      boxSizing={'border-box'}
      border={`1px solid ${CustomColors.Blue7}`}
      borderLeft={`8.5px solid ${CustomColors.Blue7}`}
      borderRadius={'6px'}>

      <Text
        fontSize={'14px'}
        color={CustomColors.Grey17}
        textAlign={'center'}>

        {props.message}
      </Text>
    </HContainer>
  );
};